import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
	
	workflowReferralEvent: EventEmitter<{ eventType: string, timestamp: Date }> = new EventEmitter();	

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }
	
	async getReferrals(page: number = 1, paging: any = {}, constraints: any = {}): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `?page=${page}`;
		url += `&size=${paging.elementsPerPage}`;
		url += `&sort=${paging.sorting.sort}`;
		url += `&constraints=${encodeURIComponent(JSON.stringify(constraints))}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response?.content) {
				let referrals = response.content;
				referrals.forEach((referral: any) => {
					this.formatReferral(referral);
				});
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async getReferralsByStatus(status: string, page: number = 1, paging: any = {}, constraints: any = {}): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `/status/${status}`;
		url += `?page=${page}`;
		url += `&size=${paging.elementsPerPage}`;
		url += `&sort=${paging.sorting.sort}`;
		url += `&constraints=${encodeURIComponent(JSON.stringify(constraints))}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response?.content) {
				let referrals = response.content;
				referrals.forEach((referral: any) => {
					this.formatReferral(referral);
				});
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getReferralsForTask(taskid: number): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `/task/${taskid}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			let referrals = response;
			referrals.forEach((referral: any) => {
				this.formatReferral(referral);
			});
			return response;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async addReferral(payload: any): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `/add`;

		try {
			const response = await firstValueFrom(this.http.post<any>(url, payload));

			let referral = response;
			this.formatReferral(referral);
			return referral;
		} catch (error) {
			return Promise.reject(error);
		}
	}	

	private formatReferral(referral: any) {
		if (!referral) return;
		var created = new Date(referral.dateCreated);
		referral.dateCreatedStr = created.toLocaleDateString('en-US') + ' ' + created.toLocaleTimeString('en-US'); 
		var due = new Date(referral.dateDue);
		referral.dateDueStr = due.toLocaleDateString('en-US') + ' ' + due.toLocaleTimeString('en-US');
		var closed = new Date(referral.dateClosed);
		referral.dateClosedStr = closed.toLocaleDateString('en-US') + ' ' + closed.toLocaleTimeString('en-US');  
	}
	
	async massComplete(payload: any): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `/mass/complete`;

		try {
			const response = await firstValueFrom(this.http.post<any>(url, payload));

			this.workflowReferralEvent.emit({
				eventType: 'complete',
				timestamp: new Date(),
			});

			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async massCancel(payload: any): Promise<any> {
		let url = this.configService.getConfig().dx.referralsURL;
		url += `/mass/cancel`;

		try {
			const response = await firstValueFrom(this.http.post<any>(url, payload));

			this.workflowReferralEvent.emit({
				eventType: 'cancel',
				timestamp: new Date(),
			});

			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
